<template>
  <div class="select-part">
    <label class="name">{{filterName}}</label>
    <div class="select-item larges" v-if="type =='letter'" >
      <span :class="{'active':curItem==item}" v-for="item in letterList" v-if="letterList" @click="chooseItem(item,index)">{{item}}</span>
    </div>
    <div class="select-item" :class="{'larges':index==0}" v-if="childItem">
      <span :class="{'active':curItem==item.name}" v-for="item in childItem" @click="chooseItem(item.name,index,item.id)" >{{item.name}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'filterItem',
  props: {
    filterName:String,
    type: String,
    childItem:Array,
    index:Number,
    curFilter:Object ,//当前选中项
  },
  data(){
    return{
      letterList:["全部","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z",'#'],
      curItem:'',
      saveChildItem:null
    }
  },
  watch:{
    curFilter:{
      handler(newval,oldval) {
        if(!newval){
          this.curItem='';
          return;
        }
        this.curItem = newval.childItem;
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true
    },
     
  },
  mounted() {
   
  },
  methods:{
    chooseItem(info,index,id=-1){
      // console.log(this.curFilter);
      let curFilter = this.curFilter;
      if(curFilter && curFilter.type == this.type &&　curFilter.childItem == info){
        this.$emit("deleteItem",{
          "index":index,
          "filterName":this.filterName,
          "childItem":info,
          "childItemId":id,
          "type":this.type
        })
        return;
      }
      this.$emit("chooseItem",{
        "index":index,
        "filterName":this.filterName,
        "childItem":info,
        "childItemId":id,
        "type":this.type
      })
    }
  }
}
</script>
<style scoped >


</style>